import { FC } from 'react'
import {
  BooleanParam,
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params'
import { useHistory } from 'react-router-dom'

import KeywordsContainingForm from 'components/idea-lab/KeywordsContainingForm'

import { trimCommaSeparatedList } from 'container/Projects/LiveProjects/Project/IdeaLab/utils'

type Props = {
  onChange: () => void
}

export const Keywords: FC<Props> = ({ onChange }) => {
  const history = useHistory()
  const [queryParams, setQueryParams] = useQueryParams({
    keyword: withDefault(StringParam, undefined),
    sug_keyword: withDefault(StringParam, undefined),
    page: withDefault(NumberParam, 1),
    content_ideas: withDefault(BooleanParam, false),
  })
  const isSuggestionsFilter =
    history.location.pathname === '/content-ideas' || queryParams.content_ideas

  const handleSubmit = (keywords: string) => {
    const formattedKeywords = trimCommaSeparatedList(keywords)
    if (isSuggestionsFilter) {
      setQueryParams({
        sug_keyword: formattedKeywords,
        page: 1,
      })
    } else {
      setQueryParams({
        keyword: formattedKeywords,
        page: 1,
      })
    }

    onChange()
  }

  return <KeywordsContainingForm onSubmit={handleSubmit} />
}
